import dayjs from 'dayjs';

import { EFilters } from 'features/Filters';
import { formatDate } from 'shared/utils';

import 'dayjs/locale/ru';

import { useFilters } from './useFilters';

dayjs.locale('ru');

export const useDateFilters = (after: EFilters, before: EFilters) => {
	const { getFilterValue, onFilterChange, onMultiFiltersChange } = useFilters();

	const valueAfter = getFilterValue(after);
	const valueBefore = getFilterValue(before);

	return {
		dateAfter: valueAfter ? dayjs(valueAfter) : null,
		dateBefore: valueBefore ? dayjs(valueBefore) : null,
		onDateChange: (value: dayjs.Dayjs | null, key: EFilters, isDateTime?: boolean, isToFilter?: boolean) => {
			const date = value?.toDate() || null;

			onFilterChange(key, formatDate(date, isDateTime ? 'json' : 'iso', isToFilter ? 'to' : 'from') || '');
		},

		onDatesChange: (
			value: [dayjs.Dayjs | null, dayjs.Dayjs | null] | null,
			key: [EFilters, EFilters],
			isDateTime?: boolean,
		) => {
			const date1 = value?.[0]?.toDate() || null;
			const date2 = value?.[1]?.toDate() || null;

			onMultiFiltersChange(
				[key[0], key[1]],
				[
					formatDate(date1, isDateTime ? 'json' : 'iso', 'from') || '',
					formatDate(date2, isDateTime ? 'json' : 'iso', 'to') || '',
				],
			);
		},
	};
};
